/* HBSKN store locator: motore della pagina /pages/store-locator e delle schede /pages/stores/<handle>.
 * Config da Liquid: HBStoreLocator.init(rootEl, CFG). Mappa self-hosted (MapLibre + tiles.hebiskin.com),
 * caricata solo quando entra in viewport. Stringhe tradotte in CFG.t (locales hbskn.sl.*).
 */
(function () {
  'use strict';

  var ROME_TZ = 'Europe/Rome';
  var FAR_KM = 50;
  var DAY_TOKENS = {
    lun: 0, lunedi: 0, 'lunedì': 0, mon: 0, monday: 0, mo: 0, montag: 0, lundi: 0,
    mar: 1, martedi: 1, 'martedì': 1, tue: 1, tuesday: 1, di: 1, dienstag: 1, mardi: 1,
    mer: 2, mercoledi: 2, 'mercoledì': 2, wed: 2, wednesday: 2, mi: 2, mittwoch: 2, mercredi: 2,
    gio: 3, giovedi: 3, 'giovedì': 3, thu: 3, thursday: 3, do: 3, donnerstag: 3, jeudi: 3,
    ven: 4, venerdi: 4, 'venerdì': 4, fri: 4, friday: 4, fr: 4, freitag: 4, vendredi: 4,
    sab: 5, sabato: 5, sat: 5, saturday: 5, sa: 5, samstag: 5, samedi: 5,
    dom: 6, domenica: 6, sun: 6, sunday: 6, so: 6, sonntag: 6, dimanche: 6
  };
  var COOP = {
    it: ['Usa Ctrl + scroll per zoomare la mappa', 'Usa ⌘ + scroll per zoomare la mappa', 'Usa due dita per muovere la mappa'],
    en: ['Use Ctrl + scroll to zoom the map', 'Use ⌘ + scroll to zoom the map', 'Use two fingers to move the map'],
    de: ['Strg + Scrollen zum Zoomen der Karte', '⌘ + Scrollen zum Zoomen der Karte', 'Mit zwei Fingern verschieben Sie die Karte'],
    fr: ['Ctrl + défilement pour zoomer la carte', '⌘ + défilement pour zoomer la carte', 'Utilisez deux doigts pour déplacer la carte']
  };

  function fill(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function km(a, b) {
    var R = 6371, r = Math.PI / 180;
    var dLat = (b.lat - a.lat) * r, dLon = (b.lng - a.lng) * r;
    var x = Math.pow(Math.sin(dLat / 2), 2) + Math.cos(a.lat * r) * Math.cos(b.lat * r) * Math.pow(Math.sin(dLon / 2), 2);
    return 2 * R * Math.asin(Math.sqrt(x));
  }
  function fmtKm(d, lang) {
    var n = d < 10 ? Math.round(d * 10) / 10 : Math.round(d);
    try { return new Intl.NumberFormat(lang).format(n); } catch (e) { return String(n); }
  }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  function isApple() {
    return /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent) && ('ontouchend' in document || /iPhone|iPad|iPod/.test(navigator.userAgent));
  }

  /* ── Orari: "lun-ven 09:30-13:00 16:00-20:00", "sab 10-20", "dom chiuso" ── */
  function parseHours(text) {
    if (!text) return null;
    var week = [null, null, null, null, null, null, null];
    var any = false;
    String(text).split(/\n|;/).forEach(function (line) {
      line = line.trim().toLowerCase();
      if (!line) return;
      var m = line.match(/^([a-zà-ÿ]+)\.?(?:\s*[-–]\s*([a-zà-ÿ]+)\.?)?\s*:?\s*(.*)$/i);
      if (!m) return;
      var d1 = DAY_TOKENS[m[1]], d2 = m[2] != null ? DAY_TOKENS[m[2]] : d1;
      if (d1 == null || d2 == null) return;
      var rest = m[3] || '';
      var ranges = [];
      if (!/chius|closed|geschlossen|ferm/.test(rest)) {
        var re = /(\d{1,2})(?:[:.](\d{2}))?\s*[-–]\s*(\d{1,2})(?:[:.](\d{2}))?/g, r;
        while ((r = re.exec(rest))) {
          ranges.push([+r[1] * 60 + (+r[2] || 0), +r[3] * 60 + (+r[4] || 0)]);
        }
      }
      for (var d = d1; ; d = (d + 1) % 7) {
        week[d] = ranges;
        any = true;
        if (d === d2) break;
      }
    });
    return any ? week : null;
  }
  function romeNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: ROME_TZ, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false })
        .formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      var idx = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 }[o.weekday];
      return { day: idx, min: (+o.hour % 24) * 60 + (+o.minute) };
    } catch (e) {
      var d = new Date();
      return { day: (d.getDay() + 6) % 7, min: d.getHours() * 60 + d.getMinutes() };
    }
  }
  function openNow(week) {
    if (!week) return null;
    var now = romeNow();
    var today = week[now.day];
    if (today == null) return null;
    return today.some(function (r) { return now.min >= r[0] && now.min < r[1]; });
  }
  function fmtMin(m) {
    return String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(m % 60).padStart(2, '0');
  }

  function directionsUrl(s) {
    if (s.gmaps) return s.gmaps;
    var dest = (s.lat != null && s.lng != null) ? s.lat + ',' + s.lng : [s.name, s.address, s.city].filter(Boolean).join(', ');
    if (isApple()) return 'https://maps.apple.com/?daddr=' + encodeURIComponent(dest) + '&q=' + encodeURIComponent(s.name);
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(dest);
  }

  /* ── Loader MapLibre (una volta sola per pagina) ── */
  var mlPromise = null;
  function loadMapLibre(jsUrl, cssUrl) {
    if (window.maplibregl) return Promise.resolve(window.maplibregl);
    if (mlPromise) return mlPromise;
    mlPromise = new Promise(function (resolve, reject) {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = cssUrl;
      document.head.appendChild(l);
      var s = document.createElement('script');
      s.src = jsUrl; s.async = true;
      s.onload = function () { window.maplibregl ? resolve(window.maplibregl) : reject(new Error('maplibre')); };
      s.onerror = function () { reject(new Error('maplibre load')); };
      document.head.appendChild(s);
    });
    return mlPromise;
  }

  function pinImage(size, fill, stroke) {
    var dpr = 2, c = document.createElement('canvas');
    c.width = c.height = size * dpr;
    var x = c.getContext('2d');
    x.scale(dpr, dpr);
    x.fillStyle = stroke; x.fillRect(0, 0, size, size);
    x.fillStyle = fill; x.fillRect(3, 3, size - 6, size - 6);
    return { width: size * dpr, height: size * dpr, data: x.getImageData(0, 0, size * dpr, size * dpr).data };
  }

  function Locator(root, cfg) {
    this.root = root;
    this.cfg = cfg;
    this.t = cfg.t || {};
    this.lang = cfg.lang || 'it';
    this.stores = (cfg.stores || []).filter(function (s) { return s.status !== 'closed'; }).map(function (s) {
      s.week = parseHours(s.hours);
      return s;
    });
    this.origin = null;
    this.map = null;
    this.selected = null;
    this.el = function (sel) { return root.querySelector(sel); };
  }

  Locator.prototype.init = function () {
    var self = this;
    this.geocodeMissing().then(function () {
      self.renderStatusBadges();
      if (self.cfg.mode === 'list') {
        self.bindList();
        self.ipGuess();
      }
      self.lazyMap();
    });
    this.bindDialogs();
    if (this.cfg.mode === 'detail') this.renderHours();
  };

  // Negozi senza coordinate (appena creati in Admin, prima del cron): geocoding server-side in cache.
  Locator.prototype.geocodeMissing = function () {
    var self = this;
    var missing = this.stores.filter(function (s) { return s.lat == null || s.lng == null; });
    return Promise.all(missing.map(function (s) {
      var q = [s.address, [s.zip, s.city].filter(Boolean).join(' '), s.country].filter(Boolean).join(', ');
      return fetch(self.cfg.crm + '/stores/geocode?q=' + encodeURIComponent(q) + '&lang=' + self.lang)
        .then(function (r) { return r.json(); })
        .then(function (g) {
          if (g && g.ok) {
            s.lat = g.lat; s.lng = g.lng;
            var card = self.root.querySelector('[data-store="' + s.handle + '"]');
            if (card) { card.dataset.lat = g.lat; card.dataset.lng = g.lng; }
          }
        }).catch(function () {});
    }));
  };

  Locator.prototype.renderStatusBadges = function () {
    var t = this.t;
    this.stores.forEach(function (s) {
      if (s.status !== 'open') return;
      var st = openNow(s.week);
      if (st == null) return;
      var nodes = document.querySelectorAll('[data-open-badge="' + s.handle + '"]');
      nodes.forEach(function (b) {
        b.textContent = st ? t.status_open_now : t.status_closed_now;
        b.classList.toggle('is-open', st);
        b.hidden = false;
      });
    });
  };

  Locator.prototype.renderHours = function () {
    var s = this.stores[0];
    var box = this.el('[data-hours]');
    if (!s || !box || !s.week) return;
    var days = String(this.t.days || '').split(',');
    var now = romeNow();
    var t = this.t;
    box.innerHTML = s.week.map(function (ranges, i) {
      var val = ranges == null ? '—' : ranges.length ? ranges.map(function (r) { return fmtMin(r[0]) + '–' + fmtMin(r[1]); }).join(' · ') : t.closed;
      return '<div class="hb-sl__hrow' + (i === now.day ? ' is-today' : '') + '"><dt>' + esc(days[i] || '') + (i === now.day ? ' <span>' + esc(t.today) + '</span>' : '') +
        '</dt><dd>' + esc(val) + '</dd></div>';
    }).join('');
    box.hidden = false;
    var raw = this.el('[data-hours-raw]');
    if (raw) raw.hidden = true;
  };

  /* ── Lista: ricerca, geolocalizzazione, ordinamento ── */
  Locator.prototype.bindList = function () {
    var self = this;
    var form = this.el('[data-search]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = form.querySelector('input').value.trim();
      if (q.length < 2) return;
      self.setMsg(self.t.locating);
      fetch(self.cfg.crm + '/stores/geocode?q=' + encodeURIComponent(q) + '&lang=' + self.lang)
        .then(function (r) { return r.json(); })
        .then(function (g) {
          if (!g || !g.ok) { self.setMsg(self.t.not_found, true); return; }
          track('sl_search', { q: q });
          self.setOrigin({ lat: g.lat, lng: g.lng, label: g.label || q }, 'search');
        })
        .catch(function () { self.setMsg(self.t.error_generic, true); });
    });
    var loc = this.el('[data-locate]');
    if (loc) {
      if (!('geolocation' in navigator)) loc.hidden = true;
      loc.addEventListener('click', function () {
        self.setMsg(self.t.locating);
        track('sl_locate', {});
        navigator.geolocation.getCurrentPosition(function (p) {
          self.setOrigin({ lat: p.coords.latitude, lng: p.coords.longitude, label: self.t.locate_btn }, 'gps');
        }, function () {
          self.setMsg(self.t.locate_denied, true);
        }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
      });
    }
    this.root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-track]');
      if (a) track(a.getAttribute('data-track'), { store: a.getAttribute('data-handle') || null });
      var card = e.target.closest('[data-store]');
      if (card && !e.target.closest('a,button')) self.select(card.getAttribute('data-store'), true);
    });
  };

  Locator.prototype.ipGuess = function () {
    var self = this;
    if (!this.stores.length) return;
    fetch(this.cfg.crm + '/stores/ipgeo').then(function (r) { return r.json(); }).then(function (g) {
      if (!g || !g.ok || self.origin) return; // non sovrascrive una ricerca già fatta
      self.setOrigin({ lat: g.lat, lng: g.lng, label: g.city || '' }, 'ip');
    }).catch(function () {});
  };

  Locator.prototype.setMsg = function (text, isErr) {
    var m = this.el('[data-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.classList.toggle('is-error', !!isErr);
    m.hidden = !text;
  };

  Locator.prototype.setOrigin = function (o, source) {
    var self = this;
    this.origin = o;
    var located = this.stores.filter(function (s) { return s.lat != null; });
    located.forEach(function (s) { s.dist = km(o, s); });
    located.sort(function (a, b) { return a.dist - b.dist; });
    var list = this.el('[data-list]');
    located.forEach(function (s) {
      var card = list && list.querySelector('[data-store="' + s.handle + '"]');
      if (!card) return;
      list.appendChild(card);
      var d = card.querySelector('[data-dist]');
      if (d) { d.textContent = fmtKm(s.dist, self.lang) + ' km'; d.hidden = false; }
    });
    var label = source === 'ip' ? fill(this.t.sorted_approx, { place: o.label }) : fill(this.t.sorted_from, { place: o.label });
    this.setMsg(o.label ? label : '');
    var nearest = located[0];
    var far = this.el('[data-far]');
    if (far) {
      var isFar = source !== 'ip' && nearest && nearest.dist > FAR_KM;
      far.hidden = !isFar;
      if (isFar) {
        far.querySelector('[data-far-title]').textContent = fill(this.t.far_title, { km: fmtKm(nearest.dist, this.lang) });
        var np = this.root.querySelector('[data-notify-place]');
        if (np && !np.value && source === 'search') np.value = o.label;
        var nl = this.root.querySelector('[data-notify-lat]'), ng = this.root.querySelector('[data-notify-lng]');
        if (nl && ng) { nl.value = o.lat; ng.value = o.lng; }
      }
    }
    if (this.map) this.showOrigin();
  };

  Locator.prototype.select = function (handle, fly) {
    var self = this;
    this.selected = handle;
    this.root.querySelectorAll('[data-store]').forEach(function (c) {
      c.classList.toggle('is-selected', c.getAttribute('data-store') === handle);
    });
    var s = this.stores.filter(function (x) { return x.handle === handle; })[0];
    if (this.map && s && s.lat != null) {
      if (fly) this.map.flyTo({ center: [s.lng, s.lat], zoom: Math.max(this.map.getZoom(), 14), speed: 1.4 });
      if (this.map.getSource('hb-stores')) this.map.getSource('hb-stores').setData(this.geojson());
      this.popup(s);
    }
  };

  /* ── Mappa ── */
  Locator.prototype.lazyMap = function () {
    var self = this;
    var box = this.el('[data-map]');
    if (!box) return;
    var start = function () {
      loadMapLibre(self.cfg.mlJs, self.cfg.mlCss).then(function (ml) { self.buildMap(ml, box); })
        .catch(function () { self.mapError(box); });
    };
    if (!('IntersectionObserver' in window)) return start();
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); }
    }, { rootMargin: '300px' });
    io.observe(box);
  };

  Locator.prototype.mapError = function (box) {
    box.classList.add('is-error');
    box.innerHTML = '<p class="hb-sl__maperr">' + esc(this.t.map_error) + '</p>';
  };

  Locator.prototype.geojson = function () {
    var sel = this.selected;
    return {
      type: 'FeatureCollection',
      features: this.stores.filter(function (s) { return s.lat != null; }).map(function (s) {
        return { type: 'Feature', geometry: { type: 'Point', coordinates: [s.lng, s.lat] },
          properties: { handle: s.handle, name: s.name, coming: s.status === 'coming_soon', sel: s.handle === sel } };
      })
    };
  };

  Locator.prototype.buildMap = function (ml, box) {
    var self = this;
    var dark = this.cfg.mapTheme === 'dark';
    var fg = dark ? '#f4f4f4' : '#0c0c0c', bg = dark ? '#0c0c0c' : '#ffffff';
    var co = COOP[this.lang] || COOP.it;
    var located = this.stores.filter(function (s) { return s.lat != null; });
    var map;
    try {
      map = new ml.Map({
        container: box,
        style: this.cfg.tiles + '/v1/style/' + (dark ? 'dark' : 'light') + '.json?lang=' + this.lang,
        center: this.cfg.center || [12.5, 42.0],
        zoom: this.cfg.zoom || 5,
        maxZoom: 17,
        attributionControl: { compact: true },
        cooperativeGestures: true,
        dragRotate: false,
        pitchWithRotate: false,
        locale: {
          'CooperativeGesturesHandler.WindowsHelpText': co[0],
          'CooperativeGesturesHandler.MacHelpText': co[1],
          'CooperativeGesturesHandler.MobileHelpText': co[2]
        }
      });
    } catch (e) { return this.mapError(box); }
    this.map = map;
    map.touchZoomRotate.disableRotation();
    map.addControl(new ml.NavigationControl({ showCompass: false }), 'top-right');
    map.on('error', function (e) { if (e && e.error && /style/i.test(String(e.error.message))) self.mapError(box); });

    map.on('load', function () {
      map.addImage('hb-pin', pinImage(18, fg, bg), { pixelRatio: 2 });
      map.addImage('hb-pin-coming', pinImage(18, bg, fg), { pixelRatio: 2 });
      map.addImage('hb-pin-sel', pinImage(26, fg, bg), { pixelRatio: 2 });
      map.addImage('hb-cluster', pinImage(34, fg, bg), { pixelRatio: 2 });
      map.addSource('hb-stores', { type: 'geojson', data: self.geojson(), cluster: located.length > 10, clusterRadius: 44, clusterMaxZoom: 11 });
      map.addLayer({ id: 'hb-clusters', type: 'symbol', source: 'hb-stores', filter: ['has', 'point_count'],
        layout: { 'icon-image': 'hb-cluster', 'icon-allow-overlap': true, 'text-field': ['get', 'point_count_abbreviated'],
          'text-font': ['Noto Sans Medium'], 'text-size': 13, 'text-allow-overlap': true },
        paint: { 'text-color': bg } });
      map.addLayer({ id: 'hb-points', type: 'symbol', source: 'hb-stores', filter: ['!', ['has', 'point_count']],
        layout: { 'icon-image': ['case', ['get', 'sel'], 'hb-pin-sel', ['get', 'coming'], 'hb-pin-coming', 'hb-pin'],
          'icon-allow-overlap': true, 'symbol-sort-key': ['case', ['get', 'sel'], 1, 0],
          'text-field': ['step', ['zoom'], '', 9, ['get', 'name']], 'text-font': ['Noto Sans Medium'], 'text-size': 12,
          'text-offset': [0, 1.3], 'text-anchor': 'top', 'text-transform': 'uppercase', 'text-letter-spacing': 0.08, 'text-optional': true },
        paint: { 'text-color': fg, 'text-halo-color': bg, 'text-halo-width': 1.5 } });

      map.on('click', 'hb-clusters', function (e) {
        var f = e.features[0];
        map.getSource('hb-stores').getClusterExpansionZoom(f.properties.cluster_id).then(function (z) {
          map.easeTo({ center: f.geometry.coordinates, zoom: z + 0.5 });
        });
      });
      map.on('click', 'hb-points', function (e) {
        var h = e.features[0].properties.handle;
        self.select(h, false);
        track('sl_marker', { store: h });
        if (self.cfg.mode === 'list') {
          var card = self.root.querySelector('[data-store="' + h + '"]');
          if (card && window.matchMedia('(min-width: 990px)').matches) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
      ['hb-points', 'hb-clusters'].forEach(function (l) {
        map.on('mouseenter', l, function () { map.getCanvas().style.cursor = 'pointer'; });
        map.on('mouseleave', l, function () { map.getCanvas().style.cursor = ''; });
      });

      if (located.length === 1) {
        map.jumpTo({ center: [located[0].lng, located[0].lat], zoom: self.cfg.mode === 'detail' ? 15 : 13 });
      } else if (located.length > 1) {
        var b = new ml.LngLatBounds();
        located.forEach(function (s) { b.extend([s.lng, s.lat]); });
        map.fitBounds(b, { padding: 60, maxZoom: 13, duration: 0 });
      }
      if (self.origin) self.showOrigin();
      if (self.cfg.mode === 'detail' && self.stores[0]) self.select(self.stores[0].handle, false);
    });
  };

  Locator.prototype.popup = function (s) {
    var ml = window.maplibregl;
    if (!ml || !this.map) return;
    if (this._popup) this._popup.remove();
    if (this.cfg.mode === 'detail') return;
    var t = this.t;
    var html = '<div class="hb-sl__pop"><strong>' + esc(s.name) + '</strong><span>' + esc([s.address, s.city].filter(Boolean).join(', ')) + '</span>' +
      '<a href="' + esc(directionsUrl(s)) + '" target="_blank" rel="noopener" data-track="sl_directions" data-handle="' + esc(s.handle) + '">' + esc(t.directions) + ' →</a></div>';
    this._popup = new ml.Popup({ offset: 16, closeButton: false, maxWidth: '260px', className: 'hb-sl__popup' })
      .setLngLat([s.lng, s.lat]).setHTML(html).addTo(this.map);
  };

  Locator.prototype.showOrigin = function () {
    var ml = window.maplibregl, o = this.origin;
    if (!ml || !this.map || !o) return;
    if (this._originMarker) this._originMarker.remove();
    var el = document.createElement('div');
    el.className = 'hb-sl__origin';
    this._originMarker = new ml.Marker({ element: el }).setLngLat([o.lng, o.lat]).addTo(this.map);
    var located = this.stores.filter(function (s) { return s.lat != null; })
      .sort(function (a, b) { return a.dist - b.dist; }).slice(0, 3);
    if (!located.length) return;
    var b = new ml.LngLatBounds();
    b.extend([o.lng, o.lat]);
    located.forEach(function (s) { b.extend([s.lng, s.lat]); });
    this.map.fitBounds(b, { padding: 70, maxZoom: 13 });
  };

  /* ── Dialog: suggerisci un negozio / avvisami ── */
  Locator.prototype.bindDialogs = function () {
    var self = this;
    this.root.querySelectorAll('[data-open-dialog]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = self.root.querySelector('#' + btn.getAttribute('data-open-dialog'));
        if (!d) return;
        if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
        track('sl_dialog_open', { dialog: btn.getAttribute('data-open-dialog') });
      });
    });
    this.root.querySelectorAll('dialog').forEach(function (d) {
      d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-close]')) d.close(); });
    });
    this.root.querySelectorAll('form[data-post]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = f.querySelector('[type=submit]');
        var out = f.querySelector('[data-form-msg]');
        var data = { lang: self.lang };
        new FormData(f).forEach(function (v, k) { data[k] = typeof v === 'string' ? v.trim() : v; });
        f.querySelectorAll('input[type=checkbox]').forEach(function (c) { data[c.name] = c.checked; });
        if (data.lat === '') delete data.lat;
        if (data.lng === '') delete data.lng;
        var consentEl = f.querySelector('input[name=consent]');
        if (consentEl) data.consent_text = consentEl.closest('label').textContent.trim();
        btn.disabled = true;
        fetch(self.cfg.crm + f.getAttribute('data-post'), {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data)
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (res.ok && res.j && res.j.ok) {
              f.classList.add('is-done');
              out.textContent = f.getAttribute('data-ok');
              out.classList.remove('is-error');
              out.hidden = false;
              track(f.getAttribute('data-event'), { city: data.city || data.place || null });
            } else {
              out.textContent = (res.j && res.j.error) || self.t.error_generic;
              out.classList.add('is-error');
              out.hidden = false;
              btn.disabled = false;
            }
          }).catch(function () {
            out.textContent = self.t.error_generic;
            out.classList.add('is-error');
            out.hidden = false;
            btn.disabled = false;
          });
      });
    });
  };

  window.HBStoreLocator = {
    init: function (root, cfg) {
      if (!root || root.__hbsl) return;
      root.__hbsl = new Locator(root, cfg);
      root.__hbsl.init();
    },
    directionsUrl: directionsUrl
  };

  // Link "Indicazioni" renderizzati da Liquid: su iOS diventano Apple Maps.
  document.addEventListener('DOMContentLoaded', function () {
    if (!isApple()) return;
    document.querySelectorAll('a[data-dir-apple]').forEach(function (a) { a.href = a.getAttribute('data-dir-apple'); });
  });
})();
